import { useContext } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { authContext } from "../../context/AuthContext";
import { checkSpeciality } from "../../utils/checkSpeciality";
import ProvArchivos from "../proveedor/ProvArchivos";
import ProvHistoriaClinica from "../proveedor/ProvHistoriaClinica";
import ProvHistorialCitas from "../proveedor/ProvHistorialCitas";
import ExpedienteClinicoMex from "./ExpedienteClinicoMex";
import ExpedienteMedicoMex from "./ExpedienteMedicoMex";

function CardActionMedicalMexico({
  t,
  cita,
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  setReload,
}) {
  const { scheduleDTO, patientDTO } = cita;
  const { auth } = useContext(authContext);

  return (
    <Card className="shadow-1 mb-3">
      <Card.Body>
        <Tabs
          defaultActiveKey="historial_citas"
          className="tabs-conference"
          transition={false}
        >
          <Tab eventKey="historial_citas" title={t("historial_citas")}>
            {scheduleDTO.doctor?.id && patientDTO.id && (
              <ProvHistorialCitas
                cita={cita}
                paciente={patientDTO}
                idDoctor={scheduleDTO.doctor.id}
                idPaciente={patientDTO.id}
                showAddCita={patientDTO?.account?.id != null}
              />
            )}
          </Tab>
          <Tab
            eventKey="historia_clinica"
            title={
              checkSpeciality(Number(cita.speciality.id))
                ? "Resumen de consulta"
                : t("historia_clinica")
            }
          >
            <ProvHistoriaClinica
              appointmentId={cita.id}
              idHM={cita.medicalHistoryDTO.id}
              auth={auth}
              idSpeciality={Number(cita.speciality.id)}
              setShowModalServer={setShowModalServer}
              setErrorServer={setErrorServer}
              setReload={setReload}
            />
          </Tab>
          <Tab eventKey="archivos" title="Archivos">
            <ProvArchivos appointmentId={cita.id} auth={auth} />
          </Tab>
          <Tab eventKey="expediente_clinico" title="Expediente clínico">
            <ExpedienteClinicoMex
              cita={cita}
              auth={auth}
              setShowModalServer={setShowModalServer}
              setErrorServer={setErrorServer}
              setShowSuccess={setShowSuccess}
            />
          </Tab>
          {/* <Tab eventKey="expediente_medico" title="Expediente médico">
            <ExpedienteMedicoMex
              appointmentId={cita.id}
              idHM={cita.medicalRecordDTO.id}
              auth={auth}
              setShowModalServer={setShowModalServer}
              setErrorServer={setErrorServer}
              setShowSuccess={setShowSuccess}
              setReload={setReload}
            />
          </Tab> */}
        </Tabs>
      </Card.Body>
    </Card>
  );
}

export default withTranslation()(CardActionMedicalMexico);
